import AbstractFormField, {AbstractFormFieldProperties} from "./AbstractFormField";
import {CSSProperties, ReactNode} from "react";
import {BorderStyle, Field} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {PortalAnnotation} from "../../../../shared/models/PortalAnnotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import {Checkbox, CheckboxProps} from "primereact/checkbox";

interface CheckboxFieldProperties extends AbstractFormFieldProperties, CheckboxProps {
	onValue: (value: string) => void;
}

export class CheckboxField extends AbstractFormField<CheckboxFieldProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let field: Field = Field.fromJson(this.props.field.get());

		let fieldElements: Array<ReactNode> = [];
		for (let [index, annotation] of FunctionHelper.applyValue(
			field.annotation, Field.getAnnotationDefault()
		).entries()) {
			if (!this.shouldRenderAnnotation(annotation)) {
				continue;
			}

			let value: string = "";
			if (FunctionHelper.exists(field.value) && FunctionHelper.exists(field.value![index])) {
				value = FunctionHelper.applyValue(field.value![index]._export, "");
			}

			let portalAnnotation: PortalAnnotation = PortalAnnotation.fromJson(
				FunctionHelper.applyValue(annotation, Field.getAnnotationDefault())
			);

			let fieldStyle: CSSProperties = {
				...this.computeFieldsStyle(portalAnnotation),
				...this.props.style
			};

			if (FunctionHelper.exists(portalAnnotation.border)) {
				fieldStyle.borderColor = portalAnnotation.border!.interiorColor;
				fieldStyle.borderWidth = portalAnnotation.border!.width!.toString();

				if (portalAnnotation.border!.style === BorderStyle.Dashed) {
					fieldStyle.borderStyle = "dashed";
				}
			}

			let classList: Array<string> = ["field", field.subType!.toLowerCase() + "-field"];
			if (FunctionHelper.exists(this.props.className)) {
				classList = classList.concat(this.props.className!.split(" "));
			}

			fieldElements.push(
				<Checkbox className={classList.join(" ")} style={fieldStyle} value={value}
						  key={field.objectKey + " " + portalAnnotation.objectKey} disabled={this.props.disabled}
						  checked={this.props.value === value} tabIndex={this.getTabIndex(annotation.objectKey)}
						  onChange={(event) => {
							  let result: string = "";

							  if (event.checked) {
								  result = event.value;
							  }

							  this.props.onValue(result);
						  }}/>
			);
		}

		return fieldElements;
	}
}